import { render } from "./GuardianThread.vue?vue&type=template&id=5f6b4f44&scoped=true"
import script from "./GuardianThread.vue?vue&type=script&lang=js"
export * from "./GuardianThread.vue?vue&type=script&lang=js"

import "./GuardianThread.vue?vue&type=style&index=0&id=5f6b4f44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6b4f44"]])

export default __exports__